import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Home.vue"),
  },
  {
    path: "/privacy/ar",
    name: "privacy_ar",
    component: () =>
      import(/* webpackChunkName: "privacy_ar" */ "../views/PrivacyAr.vue"),
  },
  {
    path: "/privacy/en",
    name: "privacy_en",
    component: () =>
      import(/* webpackChunkName: "privacy_en" */ "../views/PrivacyEn.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
